import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
	CButton,
	CImage,
	CCardBody,
	CCol,
	CRow,
} from 'compat/coreui'

export default function Footer(props) {
	const history = useNavigate()

	const searchHandlerRedirect = (e, search) => {
		e.preventDefault()
		const params = {
			// pincode: "pin",
			sr: search,
		}
		if (search == "STRAINS") {
			history({
				pathname: "/strain",
				state: params
			})
		} else if (search == "DEALS") {
			history({
				pathname: "/deals",
				state: params
			})
		} else if (search == "RECREATIONAL") {
			history({
				pathname: "/search",
				state: params
			})
		} else if (search == "DISPENSARIES") {
			history({
				pathname: "/search",
				state: params
			})
		}else if (search == "DELIVERIES") {
			history({
				pathname: "/search",
				state: params
			})
		}
	}
	return (
		<React.Fragment>

			{/* <footer className="footer"> */}
			<footer className="jp-footer">
				<div className="container">
					<CCardBody className="footer">
						<CRow>
							<CCol sm="3" className="m-auto corporare" >
								<CImage src="/images/white-logo.png" className="footer__logo"></CImage>
								<h2>CORPORATE OFFICE</h2>
								<p><img alt="" src="images/footer/pin.png"></img> Washington, DC — serving communities nationwide</p>
								<div className="social_media_mobile">
									<a href="https://www.linkedin.com/" target="_blank" ><CImage style={{ margin: "5px" }} alt='' src="images/footer/ft2.png" /></a>
									<a href="https://www.facebook.com/" target="_blank" ><CImage alt='' src="images/footer/ft3.png" /></a>
									<a href="https://twitter.com/" target="_blank" ><CImage style={{ margin: "5px" }} alt='' src="images/footer/ft4.png" /></a>
									<a href="http://google.com/" target="_blank" ><CImage alt='' src="images/footer/ft5.png" /></a>
								</div>
							</CCol>

							<CCol md="3" sm="6" xs="6" className="m-auto" >
								<h2>COMPANY</h2>
								<li><a href="/contact">Contact Us</a></li>
								<li><a href="/blog">Blog</a></li>
								<li><a href="/news">News</a></li>
								<li><a href="#">Careers</a></li>
							</CCol>

							<CCol md="3" sm="6" xs="6" className="m-auto" >
								<h2>USERS</h2>
								<li><a href="/login">Login</a></li>
								<li><a href="/join">Register</a></li>
								<li><a href="#">Forgot Password</a></li>
								<li><a href="#">Reviews</a></li>
							</CCol>
							<CCol sm="3" className="m-auto footer_buss" >
								<h2>BUSINESSES</h2>
								<li><a href="/tour"><CButton className="jp-btn-hot">Add Your Business</CButton></a></li>
								<div className="social_media">
									<li><a href="/signup">Signup</a></li>
									<h2 className="heading2">CONNECT WITH US</h2>
									<a href="https://www.linkedin.com/" target="_blank" ><CImage style={{ margin: "5px" }} alt='' src="images/footer/ft2.png" /></a>
									<a href="https://www.facebook.com/" target="_blank" ><CImage alt='' src="images/footer/ft3.png" /></a>
									<a href="https://twitter.com/" target="_blank" ><CImage style={{ margin: "5px" }} alt='' src="images/footer/ft4.png" /></a>
									<a href="http://google.com/" target="_blank" ><CImage alt='' src="images/footer/ft5.png" /></a>
								</div>
							</CCol>
						</CRow>
					</CCardBody>
					<div className="jp-footer-bottom">
						<span>© {new Date().getFullYear()} JointPlug. All rights reserved.</span>
						<span className="jp-footer-tag">Made with <span className="jp-gradient-text">♥</span> for the community</span>
					</div>
					{/* <div className="row">
							<div className="col-md-7">
								<h1 className="heading2">CORPRATE OFFICE</h1>
								<p><img alt='' src="images/ft0.png" /> 111, Tower A1, Loremlpsume Park, Gurugram India</p>
							</div>
							<div className="col-md-5">
								<h1 className="heading2">CONNECT WITH US</h1>
								<ul className="footer-socil">
									<li className=""><a href="#"><img alt='' src="images/ft1.png" /></a></li>
									<li><a href="#"><img alt='' src="images/footer/ft2.png" /></a></li>
									<li><a href="#"><img alt='' src="images/footer/ft3.png" /></a></li>
									<li><a href="#"><img alt='' src="images/footer/ft4.png" /></a></li>
									<li><a href="#"><img alt='' src="images/footer/ft5.png" /></a></li>
								</ul>
							</div>
							<div className="footer-new">
								<div className="suggested-text-home-page">
									<p>Suggested in Washington</p>
								</div>

								<div className="suggested-iteams-container">

									<div className="suggested-iteams">
										<a href="/#">
											<img alt='' src="images/11-n.png" />
											<label>Strains</label>
										</a>
									</div>

									<div className="suggested-iteams">
										<a href="/#">
											<img alt='' src="images/22-n.png" />
											<label>Deals</label>
										</a>
									</div>

									<div className="suggested-iteams">
										<a href="/#">
											<img alt='' src="images/33-n.png" />
											<label>Recreational</label>
										</a>
									</div>

									<div className="suggested-iteams">
										<a href="/#">
											<img alt='' src="images/44-n.png" />
											<label>Dispensaries</label>
										</a>
									</div>

									<div className="suggested-iteams">
										<a href="/#">
											<img alt='' src="images/55-n.png" />
											<label>Deliveries</label>
										</a>
									</div>

									<div className="suggested-iteams">
										<a href="/#">
											<img alt='' src="images/66-n.png" />
											<label>Doctors</label>
										</a>
									</div>

								</div>
							</div>
							<div className="col-md-12">
								<ul className="footelink">
									<li>COMPANY</li>
									<li><a href="#">Contact Us</a></li>
									<li><a href="/blog">Blog</a></li>
									<li><a href="#">Career</a></li>
								</ul>
								<ul className="footelink">
									<li>USERS</li>
									<li><Link to="/login">Login</Link></li>
									<li><Link to="/signup">Register</Link></li>
									<li><a href="#">Forgot Password?</a></li>
									<li><Link to="/tour">Add your Business</Link></li>
								</ul>

								<p className="text-center">JointPlug Pvt.Ltd. © 2012-2020</p>
							</div>
						</div> */}
				</div>
			</footer>
			{/* <div className="preorder_btn"><span>PRE-ORDER NOW</span></div> */}
			{/* <CCard>
					<CRow> */}

			<div className="footer-new" style={{ position: "fixed", maxHeight: "45px", zIndex: "1000" }}>
				<div className="suggested-iteams-container">

					<div className="suggested-iteams">
						<a href="/#" style={{ maxHeight: "10px" }} onClick={e => { searchHandlerRedirect(e, 'STRAINS') }}>
							<img alt='' src="images/11-n.png" />
							<label style={{ marginTop: "0px" }}>Strains</label>
						</a>
					</div>

					<div className="suggested-iteams">
						<a href="/#" onClick={e => { searchHandlerRedirect(e, 'DEALS') }}>
							<img alt='' src="images/22-n.png" />
							<label style={{ marginTop: "0px" }} >Deals</label>
						</a>
					</div>

					<div className="suggested-iteams">
						<a href="/#" onClick={e => { searchHandlerRedirect(e, 'RECREATIONAL') }}>
							<img alt='' src="images/33-n.png" />
							<label style={{ marginTop: "0px" }}>Recreational</label>
						</a>
					</div>

					<div className="suggested-iteams">
						<a href="/#" onClick={e => { searchHandlerRedirect(e, 'DISPENSARIES') }}>
							<img alt='' src="images/44-n.png" />
							<label style={{ marginTop: "0px" }}>Dispensaries</label>
						</a>
					</div>

					<div className="suggested-iteams">
						<a href="/#" onClick={e => { searchHandlerRedirect(e, 'DELIVERIES') }}>
							<img alt='' src="images/55-n.png" />
							<label style={{ marginTop: "0px" }}>Deliveries</label>
						</a>
					</div>
					{/* 
						<div className="suggested-iteams">
							<a href="/#">
								<img alt='' src="images/66-n.png" />
								<label style={{ marginTop: "0px" }}>Doctors</label>
							</a>
						</div> */}

				</div>
			</div>
			{/* </CRow>
				</CCard> */}
		</React.Fragment>
	)
}
